import * as React from 'react';

export interface SectionProps {
}

export function SectionDivider(props: SectionProps) {
  let classes = 'section-divider';

  return (
    <div className={classes} />
  );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/SectionDivider.tsx